<template>
    <div v-if="model">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo"
                            :range-inline="false"
                            :start-validations="validations.periodo"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="1">
                        <rkm-form-select
                            :options="form.quadrimestresAnos"
                            @change="handleQuadrimestreAnoChange"
                            label="Ano"
                            show-default-option
                            v-model="model.quadrimestreAno"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-select
                            :disabled="!model.quadrimestreAno"
                            :options="quadrimestres"
                            :validations="validations.quadrimestre"
                            @change="handleQuadrimestreChange"
                            label="Quadrimestre"
                            show-default-option
                            v-model="model.quadrimestre"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-select
                            :options="form.unidades"
                            @change="handleUnidadeChange"
                            default-option-text="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.infraestruturas"
                            @change="handleInfraestruturaChange"
                            default-option-text="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="form.equipes"
                            @change="handleEquipeChange"
                            default-option-text="Todas"
                            label="Equipe"
                            show-default-option
                            text-field="descricao"
                            v-model="model.equipeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="form.usuarios"
                            @change="handleUsuarioChange"
                            default-option-text="Todos"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-select
                            :options="form.tiposVisualizacao"
                            @change="handleTipoVisualizacaoChange"
                            label="Visualizar por"
                            v-model="model.tipoVisualizacao"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <template v-if="items.length > 0">
            <rkm-area
                v-if="totalizadores"
                no-margin-top
                title="Totalizadores"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="2">
                        Programados
                        <span
                            :title="tooltips.programados"
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="info-circle" />
                        </span>

                        <rkm-alert color="secondary">
                            <strong>{{ totalizadores.totalProgramados }}</strong>
                        </rkm-alert>
                    </rkm-col>

                    <rkm-col cols="2">
                        % Programados
                        <span
                            :title="tooltips.percentualProgramados"
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="info-circle" />
                        </span>

                        <rkm-alert color="secondary">
                            <strong>{{ formatPercentual(totalizadores.percentualProgramados) }}</strong>
                        </rkm-alert>
                    </rkm-col>

                    <rkm-col cols="2">
                        Espontâneos
                        <span
                            :title="tooltips.espontaneos"
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="info-circle" />
                        </span>

                        <rkm-alert color="secondary">
                            <strong>{{ totalizadores.totalEspontaneos }}</strong>
                        </rkm-alert>
                    </rkm-col>

                    <rkm-col cols="2">
                        % Espontâneos
                        <span
                            :title="tooltips.percentualEspontaneos"
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="info-circle" />
                        </span>

                        <rkm-alert color="secondary">
                            <strong>{{ formatPercentual(totalizadores.percentualEspontaneos) }}</strong>
                        </rkm-alert>
                    </rkm-col>

                    <rkm-col cols="2">
                        Total

                        <rkm-alert color="secondary">
                            <strong>{{ totalizadores.total }}</strong>
                        </rkm-alert>
                    </rkm-col>

                    <rkm-col
                        v-if="!model.unidadeId"
                        cols="2"
                    >
                        Total de unidades

                        <rkm-alert color="secondary">
                            <strong>{{ totalizadores.totalUnidades }}</strong>
                        </rkm-alert>
                    </rkm-col>

                    <rkm-col
                        v-if="!model.equipeId"
                        cols="2"
                    >
                        Total de equipes

                        <rkm-alert color="secondary">
                            <strong>{{ totalizadores.totalEquipes }}</strong>
                        </rkm-alert>
                    </rkm-col>

                    <rkm-col
                        v-if="!model.usuarioId && model.tipoVisualizacao === 'usuario'"
                        cols="2"
                    >
                        Total de profissionais

                        <rkm-alert color="secondary">
                            <strong>{{ totalizadores.totalProfissionais }}</strong>
                        </rkm-alert>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area
                no-margin-top
                title="Resultado"
            >
                <template v-slot:trailing>
                    <rkm-button
                        @click="print"
                        color="info"
                        small
                        title="Imprimir"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>

                    <rkm-button
                        @click="exportTo"
                        color="info"
                        small
                        title="Exportar"
                    >
                        <rkm-icon icon="file-export" />
                    </rkm-button>
                </template>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-table
                            :fields="fields"
                            :items="items"
                            :sort-by="sortBy"
                            :sort-desc="sortDesc"
                            @sort-changed="onSortChanged"
                        >
                            <template v-slot:head(equipeDescricao)>
                                Equipe
                                <span
                                    :title="tooltips.equipe"
                                    v-rkm-tooltip.hover
                                >
                                    <rkm-icon icon="info-circle" />
                                </span>
                            </template>

                            <template v-slot:head(totalAtendimentoDemandaProgramada)>
                                Programados
                                <span
                                    :title="tooltips.programados"
                                    v-rkm-tooltip.hover
                                >
                                    <rkm-icon icon="info-circle" />
                                </span>
                            </template>

                            <template v-slot:head(porcentagemAtendimentoDemandaProgramada)>
                                % Programados
                                <span
                                    :title="tooltips.percentualProgramados"
                                    v-rkm-tooltip.hover
                                >
                                    <rkm-icon icon="info-circle" />
                                </span>
                            </template>

                            <template v-slot:head(totalAtendimentoDemandaEspontanea)>
                                Espontâneos
                                <span
                                    :title="tooltips.espontaneos"
                                    v-rkm-tooltip.hover
                                >
                                    <rkm-icon icon="info-circle" />
                                </span>
                            </template>

                            <template v-slot:head(porcentagemAtendimentoDemandaEspontanea)>
                                % Espontâneos
                                <span
                                    :title="tooltips.percentualEspontaneos"
                                    v-rkm-tooltip.hover
                                >
                                    <rkm-icon icon="info-circle" />
                                </span>
                            </template>

                            <template v-slot:head(classificacao)>
                                Classificação
                                <span
                                    :title="tooltips.classificacao"
                                    v-rkm-tooltip.hover
                                >
                                    <rkm-icon icon="info-circle" />
                                </span>
                            </template>

                            <template v-slot:cell(porcentagemAtendimentoDemandaProgramada)="{ item }">
                                {{ formatPercentual(item.porcentagemAtendimentoDemandaProgramada) }}
                            </template>

                            <template v-slot:cell(porcentagemAtendimentoDemandaEspontanea)="{ item }">
                                {{ formatPercentual(item.porcentagemAtendimentoDemandaEspontanea) }}
                            </template>
                        </rkm-table>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </template>
    </div>
</template>

<script>
// Mixins.
import {error, file, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                periodo: {required: true},
                quadrimestre: this.model && this.model.quadrimestreAno ? {required: true} : {},
            }
        },
        quadrimestres() {
            if (!this.form || !this.model || !this.model.quadrimestreAno) {
                return []
            }

            const ano = this.form.quadrimestresAnos.find(item => item.value === this.model.quadrimestreAno)

            return ano ? ano.quadrimestres : []
        },
        tooltips() {
            return {
                equipe: 'Equipe/INE utilizada para agrupar os atendimentos considerados no indicador.',
                programados: 'Considera Consulta Agendada Programada, Cuidado Continuado e Consulta Agendada.',
                percentualProgramados: 'Percentual de atendimentos programados em relação ao total de atendimentos considerados no indicador.',
                espontaneos: 'Considera Escuta Inicial/Orientação, Consulta no Dia e Atendimento de Urgência.',
                percentualEspontaneos: 'Percentual de atendimentos espontâneos em relação ao total de atendimentos considerados no indicador.',
                classificacao: 'Classificação do resultado do indicador conforme as faixas definidas pelo Ministério da Saúde.',
            }
        },
        fields() {
            return this.model && this.model.tipoVisualizacao === 'usuario' ? [
                {key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true},
                {key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true},
                {key: 'equipeDescricao', label: 'Equipe', sortable: true},
                {key: 'usuarioNome', label: 'Profissional', sortable: true},
                {key: 'totalAtendimentoDemandaProgramada', label: 'Programados', class: 'text-nowrap', sortable: true},
                {key: 'porcentagemAtendimentoDemandaProgramada', label: '% Programados', class: 'text-nowrap', sortable: true},
                {key: 'totalAtendimentoDemandaEspontanea', label: 'Espontâneos', class: 'text-nowrap', sortable: true},
                {key: 'porcentagemAtendimentoDemandaEspontanea', label: '% Espontâneos', class: 'text-nowrap', sortable: true},
                {key: 'totalAtendimento', label: 'Total', sortable: true},
                {key: 'classificacao', label: 'Classificação', class: 'text-nowrap', sortable: true},
            ] : [
                {key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true},
                {key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true},
                {key: 'equipeDescricao', label: 'Equipe', sortable: true},
                {key: 'totalAtendimentoDemandaProgramada', label: 'Programados', class: 'text-nowrap', sortable: true},
                {key: 'porcentagemAtendimentoDemandaProgramada', label: '% Programados', class: 'text-nowrap', sortable: true},
                {key: 'totalAtendimentoDemandaEspontanea', label: 'Espontâneos', class: 'text-nowrap', sortable: true},
                {key: 'porcentagemAtendimentoDemandaEspontanea', label: '% Espontâneos', class: 'text-nowrap', sortable: true},
                {key: 'totalAtendimento', label: 'Total', sortable: true},
                {key: 'classificacao', label: 'Classificação', class: 'text-nowrap', sortable: true},
            ]
        },
    },
    created() {
        this.repositories = {
            exportacao: this.getConectaSusRepository('exportacao.atencaoBasica'),
            impressao: this.getConectaSusRepository('impressao.atencaoBasica'),
            relatorioAcessoCuidadoProgramado: this.getConectaSusRepository('atencaoBasica.relatorioAcessoCuidadoProgramado'),
        }

        this.load()
    },
    data() {
        return {
            form: null,
            items: [],
            model: null,
            others: {moment},
            sortBy: 'unidadeNomeFantasia',
            sortDesc: false,
            totalizadores: null,
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.relatorioAcessoCuidadoProgramado.create()
                .then((response) => {
                    this.form = response.data.form
                    this.model = response.data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getRequest() {
            return {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                quadrimestreAno: this.model.quadrimestreAno,
                quadrimestre: this.model.quadrimestre,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                equipeId: this.model.equipeId,
                usuarioId: this.model.usuarioId,
                tipoVisualizacao: this.model.tipoVisualizacao,
            }
        },
        formatPercentual(valor) {
            return `${Number(valor || 0).toFixed(2).replace('.', ',')}%`
        },
        search() {
            const request = this.getRequest()

            this.setLoading()

            this.repositories.relatorioAcessoCuidadoProgramado.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.items = Object.assign(response.data.itens)
                    this.totalizadores = Object.assign(response.data.totalizadores)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.equipes = []
            this.form.usuarios = []

            this.model.periodo = {
                start: null,
                end: null,
            }

            this.model.quadrimestreAno = null
            this.model.quadrimestre = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.equipeId = null
            this.model.usuarioId = null
            this.model.tipoVisualizacao = 'equipe'

            this.items = []
            this.totalizadores = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        print() {
            this.setLoading()

            const request = {
                ...this.getRequest(),
                sortBy: this.sortBy ? this.camelToSnake(this.sortBy) : null,
                sortDesc: this.sortDesc,
            }

            this.repositories.impressao.relatorioAcessoCuidadoProgramado(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {
            this.setLoading()

            const request = {
                ...this.getRequest(),
                sortBy: this.sortBy ? this.camelToSnake(this.sortBy) : null,
                sortDesc: this.sortDesc,
            }

            this.repositories.exportacao.relatorioAcessoCuidadoProgramado(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        getFaixasQuadrimestre() {
            return [
                {id: 1, startMD: '01-01', endMD: '04-30'},
                {id: 2, startMD: '05-01', endMD: '08-31'},
                {id: 3, startMD: '09-01', endMD: '12-31'},
            ]
        },
        applyQuadrimestreAoPeriodo() {
            if (!this.model.quadrimestreAno || !this.model.quadrimestre) {
                return
            }

            const faixa = this.getFaixasQuadrimestre().find(item => item.id === this.model.quadrimestre)

            if (!faixa) {
                return
            }

            this.model.periodo = {
                start: this.others.moment(`${this.model.quadrimestreAno}-${faixa.startMD}`, 'YYYY-MM-DD').toDate(),
                end: this.others.moment(`${this.model.quadrimestreAno}-${faixa.endMD}`, 'YYYY-MM-DD').toDate(),
            }
        },
        syncQuadrimestreComPeriodo(periodo) {
            if (!periodo || !periodo.start || !periodo.end) {
                this.model.quadrimestreAno = null
                this.model.quadrimestre = null

                return
            }

            const start = this.others.moment(periodo.start)
            const end = this.others.moment(periodo.end)

            if (start.year() !== end.year()) {
                this.model.quadrimestreAno = null
                this.model.quadrimestre = null

                return
            }

            const faixa = this.getFaixasQuadrimestre().find(item => (
                item.startMD === start.format('MM-DD') && item.endMD === end.format('MM-DD')
            ))

            const ano = faixa && this.form.quadrimestresAnos.find(item => item.value === start.year())

            this.model.quadrimestreAno = ano ? start.year() : null
            this.model.quadrimestre = ano ? faixa.id : null
        },
        handleQuadrimestreAnoChange() {
            this.model.quadrimestre = null
        },
        handleQuadrimestreChange() {
            this.applyQuadrimestreAoPeriodo()
        },
        handleUnidadeChange(value) {
            this.form.infraestruturas = []
            this.form.equipes = []
            this.form.usuarios = []
            this.model.infraestruturaId = null
            this.model.equipeId = null
            this.model.usuarioId = null

            this.items = []
            this.totalizadores = null

            const request = {
                listar: 'infraestruturas',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: value,
            }

            this.setLoading()

            this.repositories.relatorioAcessoCuidadoProgramado.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                    this.form.equipes = Object.assign(response.data.equipes)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleInfraestruturaChange(value) {
            this.form.equipes = []
            this.form.usuarios = []
            this.model.equipeId = null
            this.model.usuarioId = null

            this.items = []
            this.totalizadores = null

            const request = {
                listar: 'equipes',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: value,
            }

            this.setLoading()

            this.repositories.relatorioAcessoCuidadoProgramado.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.equipes = Object.assign(response.data.equipes)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleEquipeChange(value) {
            this.form.usuarios = []
            this.model.usuarioId = null

            this.items = []
            this.totalizadores = null

            const request = {
                listar: 'usuarios',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                equipeId: value,
            }

            this.setLoading()

            this.repositories.relatorioAcessoCuidadoProgramado.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.form.usuarios = Object.assign(response.data.usuarios))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUsuarioChange() {
            this.items = []
            this.totalizadores = null
        },
        handleTipoVisualizacaoChange() {
            this.items = []
            this.totalizadores = null
        },
        onSortChanged(context) {
            this.sortBy = context.sortBy
            this.sortDesc = context.sortDesc
        },
    },
    mixins: [error, file, repository, stringCase],
    watch: {
        'model.periodo': {
            deep: true,
            handler(value) {
                this.syncQuadrimestreComPeriodo(value)

                this.form.unidades = []
                this.form.infraestruturas = []
                this.form.equipes = []
                this.form.usuarios = []
                this.model.unidadeId = null
                this.model.infraestruturaId = null
                this.model.equipeId = null
                this.model.usuarioId = null

                this.items = []
                this.totalizadores = null

                if (value.start === null || value.end === null)  {
                    return
                }

                const request = {
                    listar: 'unidades',
                    periodo: {
                        start: this.others.moment(value.start).format('DD/MM/YYYY'),
                        end: this.others.moment(value.end).format('DD/MM/YYYY'),
                    },
                }

                this.setLoading()

                this.repositories.relatorioAcessoCuidadoProgramado.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.form.unidades = Object.assign(response.data.unidades)
                        this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                        this.form.equipes = Object.assign(response.data.equipes)
                        this.form.usuarios = Object.assign(response.data.usuarios)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            },
        },
    },
}
</script>